

















import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import HeaderComponents from "./../../../../../Assets/Card/Header/Header.vue";
import BodyComponents from "./../../../../../Assets/Card/Body/Body.vue";
import FooterComponents from "./../../../../../Assets/Card/Footer/Footer.vue";
import WorkFlowStepDialogComponents from "./../WorkFlowStepMapping/WorkFlowStepMapping.vue"
import Axios from 'axios';
/**
 * Component's properties and events
 */
@Component({
    components: {
        HeaderComponents,
        BodyComponents,
        WorkFlowStepDialogComponents,
        FooterComponents
    }
})
export default class WorkFlowPermissionComponent extends Vue {

    data() {
        return this.$store.state.workFlowPermissionIndex;
    }

    //#. The beforeCreate() hook observes data and initialization events in your component.
    beforeCreate() {
    }

    //#. The created() hook is invoked when Vue has set up events and data observation.
    created() {
    }

    //#. The beforeMount() method is invoked after our template has been compiled and our virtual DOM updated by Vue.
    beforeMount() {
    }

    //#. The mounted() method gives you access to templates and enables interaction with the DOM.
    mounted() {
        
        }

        // #. The beforeUpdate hook runs after data changes on your component and the update cycle begins, right before the DOM is patched and re- rendered.
        beforeUpdate() {
        }

        // #. The updated hook runs after data changes on your component and the DOM re-renders
        updated() {
        }

        // #. beforeDestroy is fired right before teardown. Your component will still be fully present and functional.
        beforeDestroy() {
        }

        // #. By the time you reach the destroyed hook, there�s pretty much nothing left on your component
        destroyed() {
        }
        select(item) {
            var itemval = 0;
            // item = (item == true ? 1 : (item == null ? 0 : 0));
            if (item == true)
                itemval = 1;
            else if (item == null)
                itemval = 0;
            else
                itemval = 0;
            return itemval;

        }
        savePermission() {
            let dashboard = this.$store.state.dashboard;
            this.$store.state.workFlowPermissionIndex.selected = [];
            var selectedmenus = this.$store.state.workFlowPermissionIndex.menus;
            var postdata = {
                roleMenu: selectedmenus
            };
            Axios.post('/api/RoleMenuMapping/SavePermission/?roleMenuMasterId='
                + this.$store.state.workFlowPermissionIndex.componentKeyId, selectedmenus, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(record => {
                    if (record.data.Result == 'OK') {
                        dashboard.color = "success";
                        dashboard.text = record.data.Message;
                        dashboard.snackbar = true;
                    } else {
                        dashboard.color = "error";
                        dashboard.text = record.data.Message;
                        dashboard.snackbar = true;
                    };

                })
                .catch(function () {
                    console.log('FAILURE!!');
                });

        }

        toggleAll() {
            if (this.$store.state.workFlowPermissionIndex.length)
                this.$store.state.workFlowPermissionIndex.selected = [];
            else
                this.$store.state.workFlowPermissionIndex.selected = this.$store.state.workFlowPermissionIndex.items.slice();
        }

        showWorkflowStep() {
            this.$store.state.tooltip.showMore = false;
        }
    };
